<template>
    <a-card :bordered="false">
      <a-form-item><a @click="routeBack">&lt;&lt; 返回</a></a-form-item>
      <detail-list title="物流上传详情" v-if="mdl">
        <detail-list-item term="物流单号">{{ mdl.logisticsNo }}</detail-list-item>
        <detail-list-item term="上传地址">{{ mdl.upUrl }}</detail-list-item>
        <detail-list-item term="上传参数">{{ mdl.params }}</detail-list-item>
        <detail-list-item term="上传系统">{{ mdl.softCodeName }}</detail-list-item>
        <detail-list-item term="上传状态">{{ mdl.upStatusName }}</detail-list-item>
        <detail-list-item term="失败次数">{{ mdl.failCount }}</detail-list-item>
        <detail-list-item term="上传时间">{{mdl.updateTime | formatDate}}</detail-list-item>
        <detail-list-item term="上传说明">{{ mdl.remark }}</detail-list-item>
      </detail-list>
    </a-card>
  </page-view>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import Moment from 'moment'
import storage from "@/utils/storage"


const DetailListItem = DetailList.Item

export default {
  components: {
    DetailList,
    DetailListItem
  },
  data () {
    return {
      mdl: null
    }
  },
  mounted () {
    this.initData()
  },
  filters: {
    formatDate (value) {
      return Moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    routeBack(){
      localStorage.setItem('goback', "true");
      this.$router.back(-1)
    },
    initData () {
      let cache = storage.fetch("cache-UploadDetail");
        if (cache){
            this.mdl = JSON.parse(cache);
        } 
    }
  }
}
</script>



